<template>
  <div
    v-clickoutside="close"
    :class="{ open: isOpened }"
    class="dropdown-wrap"
  >
    <label>{{ label }}</label>

    <div
      class="dropdown-field"
      @click="toggleListOpened"
    >
      {{ getSelectedItem() }}
    </div>

    <ul
      v-if="isOpened"
      class="dropdown-list"
    >
      <li
        v-for="(item, index) in items"
        :key="index"
        :class="{ selected: item.value === selectedItem }"
        @click="selectItem(item)"
      >
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>

<script>
  import Clickoutside from 'element-ui/src/utils/clickoutside'

  export default {
    directives: {
      Clickoutside
    },
    props: {
      items: {
        type: Array,
        required: true
      },
      selectedItem: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        required: false,
        default: ''
      }
    },

    data() {
      return {
        isOpened: false
      }
    },

    methods: {
      getSelectedItem() {
        const item = this.items.find((o) => o.value === this.selectedItem)
        return item ? item.title : ''
      },
      toggleListOpened() {
        this.isOpened = !this.isOpened
      },
      close() {
        this.isOpened = false
      },
      selectItem(item) {
        this.toggleListOpened()
        this.$emit('select', item.value)
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import '~assets/styles/common.scss';
  @import '~assets/styles/components/dropdown.scss';

  .dropdown-wrap {
    position: relative;
    border-radius: 3px;

    &:not(:last-of-type) {
      margin: 0;
    }

    .dropdown-field {
      position: relative;
      font-size: em(14);
      line-height: 48px;
      border: none;
      height: 48px;
      border-radius: 3px;
      padding: 0 28px 0 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      text-transform: none;

      &:after {
        top: calc(50% - 4px);
        right: 14px;
        content: $icon-arrow-right-thin-medium;
        color: $blue-medium;
      }
    }

    .dropdown-list {
      box-shadow: 0 2px 8px 0 hexToRGBA(#000000, 0.12);
      border-radius: 3px;
      position: absolute;
      height: auto;
      top: 52px;
      padding: 0;
      display: block;

      li {
        line-height: 44px;
        height: 44px;
        border: none;
        padding: 0 9px;
        position: relative;

        &.selected {
          background-color: $gray-marble;
          color: $blue-medium;

          &:after {
            position: absolute;
            content: '';
            display: block;
            width: 5px;
            height: 10px;
            border: solid $blue-medium;
            border-width: 0 2px 2px 0;
            transform: rotate(45deg);
            background: none;
            box-shadow: none;
            border-radius: 0;
            top: 16px;
            right: 17px;
          }
        }
      }
    }

    label {
      pointer-events: none;
      left: 10px;
      top: 7px;
      position: absolute;
      @include text-overflow();
      width: 65%;
      font-size: em(11);
      line-height: 13px;
      color: $input-placeholder;
    }
  }
</style>
